<template>
  <div class="gseaHallmark">
    <a-spin :spinning="loading_detable" :indicator="indicator">
      <a-row>
        <a-col :span="24">
          <a-row>
            <a-col :span="12" style="text-align: center">
              <a-button type="primary" @click="changeData('NT')"
                ><a-icon
                  type="check"
                  style="color: white"
                  v-if="this.marker == 'NT'"
                />Enriched in phenotype: Non-targeting cells</a-button
              >
            </a-col>
            <a-col :span="12" style="text-align: center">
              <a-button type="danger" @click="changeData('Treat')"
                ><a-icon
                  type="check"
                  style="color: white"
                  v-if="this.marker == 'Treat'"
                />Enriched in phenotype: CRISPR-edited cells</a-button
              >
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <vxe-toolbar>
            <template #buttons>
              <vxe-input
                v-model="filterName_detable"
                type="search"
                placeholder="Input a key word"
                @keyup="searchEvent_detable"
              ></vxe-input>
              <vxe-button @click="exportDataEvent"
                ><a-icon type="cloud-download" /> Download</vxe-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            border
            show-overflow
            row-id="id"
            size="small"
            ref="xTable"
            :data="tableData_detable"
            align="center"
            header-align="center"
            :column-config="{ isHover: true }"
            :row-config="{ isCurrent: true, isHover: true }"
            :sort-config="{
              showIcon: false,
              trigger: all,
              defaultSort: { field: 'fdrp', order: 'asc' },
            }"
            @header-cell-click="headerCellClickEvent"
          >
            <vxe-column type="expand" width="40">
              <template #content="{ row }">
                <object
                  v-if="row.view.endsWith('.pdf')"
                  :data="'http://research.gzsys.org.cn/perturbdb/' + row.view"
                  width="100%"
                  height="500"
                ></object>
                <div
                  style="
                    margin-left: 20px;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                  v-else
                >
                  Besides those passing test, only the top 10 scoring gene sets
                  used for detailed reports and plotting.
                </div>
              </template>
            </vxe-column>
            <vxe-column field="terms" title="Term" type="html" width="40%">
              <template #default="{ row }">
                <!-- 做一个terms的外部超链接 -->
                <a :href="row.source" target="_blank" style="color: blue">
                  {{ row.terms }}</a
                >
              </template>
            </vxe-column>
            <vxe-column field="es" title="ES" sortable type="html">
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <vxe-column field="nes" title="NES" sortable>
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <vxe-column field="nomp" title="NOM p-val" sortable>
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <vxe-column field="fdrp" title="FDR q-val" sortable>
              <template #header="{ column }">
                <span>{{ column.title }}</span>
                <span class="custom-sort" :class="{ 'is-order': column.order }">
                  <i
                    :class="[
                      column.order
                        ? `vxe-icon-sort-numeric-${column.order}`
                        : 'vxe-icon-sort',
                    ]"
                  ></i>
                </span> </template
            ></vxe-column>
            <template #empty>
              <span style="color: grey"> No more data! </span>
            </template>
          </vxe-table>

          <vxe-pager
            background
            size="small"
            :loading="loading_detable"
            :current-page="tablePage_detable.currentPage"
            :page-size="tablePage_detable.pageSize"
            :total="tablePage_detable.totalResult"
            :page-sizes="[10, 20]"
            :layouts="[
              'PrevPage',
              'JumpNumber',
              'NextPage',
              // 'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange_table"
          >
          </vxe-pager
        ></a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";

export default {
  props: ["gene", "dataset"],
  data() {
    return {
      //总的数据
      gsea: "",
      marker: "NT",
      //相关性分析
      corModal: false,
      gene1: "",
      gene2: this.gene,
      //加载
      spinning: false,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  created() {
    this.loading_detable = true;
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/gene_gseaHallmark.php",
        {
          params: {
            dataset: this.dataset,
            gene: this.gene,
            datatype: "gseaHallmark",
          },
        }
      )
      .then((response) => {
        // console.log(response.data);
        // const convertedArray = response.data.filter((item) => {
        //   item.fc = parseFloat(item.fc).toFixed(4);
        //   item.pvalue = parseFloat(item.pvalue);
        //   item.padj = parseFloat(item.padj);
        //   return true; // 返回true以保留所有对象
        // });
        this.gsea = response.data;
        this.getdata_detable = response.data["NT"];
        this.findList_detable(this.getdata_detable);
        this.loading_detable = false;
      });
  },

  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    changeData(value) {
      this.spinning = true;
      this.marker = value;
      this.getdata_detable = this.gsea[value];
      this.findList_detable(this.getdata_detable);
      this.spinning = false;
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.gene +
            "." +
            this.dataset +
            "_enrichedIn_" +
            this.marker +
            "_GSEA-Hallmark",
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.gene +
            "." +
            this.dataset +
            "-" +
            this.filterName_detable +
            "_related_enrichedIn_" +
            this.marker +
            "_GSEA-Hallmark",
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.corModal = false;
    },
    handleCancel() {
      this.corModal = false;
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["terms"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>

<style>
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
